<template>
	<div class="default-scroll" @click="scrolldown">
		<span v-if="label"> {{ label }}</span>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="17"
			height="16"
			viewBox="0 0 17 16"
			fill="none"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M8.47941 1.5C8.75555 1.5 8.97941 1.72386 8.97941 2V12.7929L13.7925 7.97978C13.9878 7.78452 14.3044 7.78452 14.4996 7.97978C14.6949 8.17504 14.6949 8.49162 14.4996 8.68689L8.83296 14.3536C8.6377 14.5488 8.32112 14.5488 8.12586 14.3536L2.45919 8.68689C2.26393 8.49162 2.26393 8.17504 2.45919 7.97978C2.65445 7.78452 2.97104 7.78452 3.1663 7.97978L7.97941 12.7929V2C7.97941 1.72386 8.20327 1.5 8.47941 1.5Z"
				fill="white"
			/>
		</svg>
	</div>
</template>

<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const label = computed(() => props.fields?.label?.value);

function scrolldown() {
	document.querySelector(".page").scrollTo({
		top: window.innerHeight / 1.4,
		behavior: "smooth",
	});
}
</script>

<style lang="scss">
@keyframes bounce {
	0%,
	20%,
	50%,
	80%,
	100% {
		transform: translateY(0);
		opacity: 1;
	}

	40% {
		transform: translateY(-50%);
	}

	60% {
		transform: translateY(-20%);
	}
}

.default-scroll {
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	text-align: center;
	font-size: var(--text-sm, 14px);
	font-family: var(--primary-font, sans-serif);
	font-weight: 300;
	line-height: 140%;
	color: var(--color-white, #fff);
	width: 100%;
	display: flex;
	align-content: center;
	justify-content: center;
	gap: var(--spacing-1, 8px);
	margin: var(--spacing-4, 32px) 0 120px 0;

	svg {
		width: 16px;
		height: 16px;
		animation: bounce 2s ease infinite;
	}
}
</style>
